import React, { Component } from 'react'
import Switch from "react-switch";
import { Notifications } from '../../common/notification';
import { getUser } from '../../../actions/session';
import Axios from 'axios';
import { GATEWAY_CREATE } from '../../../config/rest_endpoints';


 class AddGateway extends Component {
     constructor(props) {
         super(props)
         this.state = {
             User:getUser(),
            switched:true,
            ip:'',
            sessions: '',
             port:5060,
            cps: '',
            prefix: '',
            isLoad:false
         }
         this.onHandleChange = this.onHandleChange.bind(this)
         this.onSubmit = this.onSubmit.bind(this)
         this.toggleSwitch = this.toggleSwitch.bind(this)
     }

     toggleSwitch() {
         this.setState({switched:!this.state.switched})
     }

     onHandleChange(e) {
         this.setState({
             [e.target.name]:e.target.value
         })
     }

     onSubmit() {
        const {User,switched,ip,port,sessions,cps,prefix} = this.state
        var userId = this.props.ID
        console.log('userId :>> ', userId);
        var payload = {
            "status":switched,
            "ip":ip,
            "port": parseInt(port),
            "cps" : cps === '' ? null : parseInt(cps),
            "sessions": sessions === '' ? null : parseInt(sessions),
            "prefix":prefix === '' ? null : prefix
        }
         this.setState({ isLoad: true })
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.post(`${GATEWAY_CREATE}/${userId}/gateway/create`, payload, { headers }).then(res => {
            if (res) {
               console.log('res :>> ', res);
               Notifications.notify("Gateway created", "Success", "success")
               this.props.close()
               this.props.listing()
                this.setState({ isLoad: false, cps: '', sessions: '', ip: '', prefix: '' })
            }
            else {
                Notifications.notify("failed carrier update", "Failed", "error")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
                isLoad: false
            })
        })

     }
     
    render() {
        const {switched,ip,port,sessions,cps,prefix} = this.state
        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>IP</label>
                        <input type="email" className="form-control" name="ip" value={ip} onChange={this.onHandleChange} placeholder="Enter gateway ip" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Port</label>
                        <input type="number" className="form-control" name="port" value={port} onChange={this.onHandleChange} placeholder="Enter gateway port" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Sessions</label>
                        <input type="number" className="form-control" name="sessions" value={sessions} onChange={this.onHandleChange} placeholder="Enter sessions" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>CPS</label>
                        <input type="number" className="form-control" name="cps" value={cps} onChange={this.onHandleChange} placeholder="Enter cps" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Prefix</label>
                        <input type="text" className="form-control" name="prefix" value={prefix} onChange={this.onHandleChange} placeholder="e.g. 3353#" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group mt-1">
                            <div className="row">
                                <div className="col-md-3 mt-1">
                                    <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Status</label>
                                </div>
                                <div className="col-md-1 mr-3">
                                    <Switch onChange={this.toggleSwitch} checked={switched} onColor="#00C292" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* row */}    
                <div className="row" style={{borderTop:'1px solid #e9ecef'}}>
                    <div className="col-md-6 ml-auto">
                        <button type="submit " className="mt-2 main-button btn btn-sm btn-success float-right" onClick={this.onSubmit} >Add Gateway<i class={this.state.isLoad ? "icon-spinner4 spinner ml-1 " : 'icon-file-plus ml-1 '}></i></button>
                    </div>
                </div>
            </div>
        )
    }
}
export default AddGateway